import React from 'react';
import styled from 'styled-components';
import { bp } from 'Styles/helpers';
import screen from 'superior-mq';
import { rem } from 'polished';
import Container from '../../container';
import Button from '../../button';
import Waves from '../../waves';

const ProgramStartFundraiser = () => (
  <FundraiserSection dark>
    <Container>

      <h5>Start your own initiative</h5>

      <Button isdark href="/start-a-fundraiser">
        Start a fundraiser
      </Button>

    </Container>

    <Waves
      position="bottom"
      alignment="bottom"
      height={328}
      color="#fff"
    />
  </FundraiserSection>
);

const FundraiserSection = styled.section`
  position: relative;
  padding: 120px 0 338px;
  text-align: center;
  color: #fff;
  background-color: ${props => props.theme.black};

  h5 {
    margin-bottom: 50px;
    font-family: ${props => props.theme.sansFont};
    font-size: ${rem(44)};
  }

  ${screen.below(bp.tablet, `
    padding: 70px 0 176px;
  `)};
`;

export default ProgramStartFundraiser;
